import { render } from "./RefusalAccept.vue?vue&type=template&id=2ab9b7c4"
import script from "./RefusalAccept.vue?vue&type=script&lang=js"
export * from "./RefusalAccept.vue?vue&type=script&lang=js"

import "./RefusalAccept.vue?vue&type=style&index=0&id=2ab9b7c4&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__